import { useEffect } from 'react'

/*
 * Panels nest: the mobile filters panel opens the address search panel over
 * itself. A plain write to `body.style.overflow` let the inner panel release
 * the lock the outer one still needs, so the holders are counted instead. The
 * count lives on the element it guards, which keeps it out of module state.
 */
const HOLDERS_ATTRIBUTE = 'scrollLockHolders'

const readHolders = () => Number(document.body.dataset[HOLDERS_ATTRIBUTE] ?? 0)

const writeHolders = (holders: number) => {
  if (holders > 0) {
    document.body.dataset[HOLDERS_ATTRIBUTE] = String(holders)
    return
  }

  delete document.body.dataset[HOLDERS_ATTRIBUTE]
}

const usePreventPageScroll = (prevent: boolean) => {
  useEffect(() => {
    if (!prevent) {
      return
    }

    writeHolders(readHolders() + 1)
    document.body.style.overflow = 'hidden'

    return () => {
      const holders = Math.max(readHolders() - 1, 0)

      writeHolders(holders)

      if (holders === 0) {
        document.body.style.overflow = 'unset'
      }
    }
  }, [prevent])
}

export { usePreventPageScroll }
